import type { EarnedBadge, EarnedBadgeType } from '@/apiTypes/EarnedBadgeTypes';
import { LESSONS_PATH } from '@/pages/Explore/Lessons/lessonRoutes';
import lessonsBadgeArt from '@/assets/badges/lessons_badge.svg';

export interface EarnedBadgeTypeConfig {
    art: string;
    sheenAngle: string;
    tagLabel: string;
    exploreLabel: string;
    explorePath: string;
}

export const EARNED_BADGE_TYPES: Record<EarnedBadgeType, EarnedBadgeTypeConfig> = {
    lesson: {
        art: lessonsBadgeArt,
        sheenAngle: '119deg',
        tagLabel: '#lessons',
        exploreLabel: 'Explore Lessons',
        explorePath: LESSONS_PATH,
    },
};

export const isKnownBadge = (badge: EarnedBadge): boolean => Object.prototype.hasOwnProperty.call(EARNED_BADGE_TYPES, badge.type);

export const formatBadgeDate = (iso: string): string =>
    new Date(iso).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
